module.exports = __webpack_public_path__ + "static/img/accredit_prompt_bg.4d9cb3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h5/official/accredit_prompt_bg.png
// module id = km+5
// module chunks = 0